<mat-dialog-content>
  <div class="container">
    <div class="close-icon">
      <mat-icon mat-dialog-close>close</mat-icon>
    </div>
    <div id="print-section" class="orderprinted thermal-print">
      <h1 class="fontstrong center fontsize">{{orderObj.branch.name | uppercase}}</h1>
      <br>
      <div *ngIf="!isSecondPrint && !isComanda">
        <p class="fontsize">Nº Orden: {{orderObj.number ? orderObj.number : 0}}</p><br>
        <div *ngIf="orderObj.client">
          <h1 class="fontstrong fontsize">CLIENTE</h1>
          <p class="fontsize">Nombre: {{orderObj.client.fullname}}</p>
          <p class="fontsize">Teléfono: {{orderObj.client.phone}}</p>
          <br>
        </div>
        <div *ngIf="orderObj.billName && orderObj.billName !== ''">
          <h1 class="fontstrong fontsize">FACTURACIÓN</h1>
          <p class="fontsize">Razón social: {{orderObj.billName}}</p>
          <p class="fontsize">NIT/CI: {{orderObj.billNit}}</p>
          <br><br>
        </div>
        <h1 class="fontstrong fontsize">PEDIDO</h1>
        <p *ngIf="orderObj.deliveryMethod" class="fontsize">
          Tipo: {{orderObj.deliveryMethod.name}}
        </p>
        <p *ngIf="orderObj.location && orderObj.location.reference" class="fontsize">
          Ubicación: {{orderObj.location.reference}}
        </p>
        <p *ngIf="orderObj.paymentMethod" class="fontsize">
          Pago: {{orderObj.paymentMethod.name}}
        </p>
        <br><br>
        <h1 class="fontstrong center fontsize">PRODUCTOS</h1>
        <div *ngFor="let order of orderItems" class="mb-3">
          <table>
            <tr>
              <td class="fontsize">- {{order.quantity}} {{order.product}}
                <p class="ml-3 mt-n1 mb-0">({{order.productVariant}})</p></td>
              <td class="fontsize">{{order.principalProductTotalPrice | number: '1.2-2'}}</td>
            </tr>
          </table>
          <div *ngIf="order.specifications && order.specifications.length > 0" class="my-2">
            <p class="fontsize ml-3">Especificaciones</p>
            <div *ngFor="let spec of order.specifications">
              <p class="fontsize ml-3">x {{spec.name ? spec.name : spec}}</p>
            </div>
          </div>
          <div *ngIf="order.additives && order.additives.length > 0">
            <div *ngFor="let addit of order.additives | groupBy: 'groupName' | pairs">
              <div *ngIf="addit[0] !== 'undefined'" class="my-1">
                <p class="fontsize  ml-3">{{addit[0]}}:</p>
              </div>
              <div *ngIf="addit[0] === 'undefined'" class="my-1">
                <p class="fontsize  ml-3">Acompañamientos:</p>
              </div>
              <div *ngFor="let g of addit[1]">
                  <p class="fontsize  ml-3">x {{g.product}}</p>
              </div>
            </div>
          </div>
          <div *ngIf="order.extras && order.extras.length > 0" class="mt-2">
            <p class="fontsize ml-3">Extras</p>
            <table>
              <tr *ngFor="let extra of order.extras">
                <td class="fontsize"><span class=" ml-3">x {{extra.quantity}} {{extra.product ? extra.product : extra.name}}</span></td>
                <td class="fontsize">{{extra.totalPrice | number: '1.2-2'}}</td>
              </tr>
            </table>
          </div>
          <div *ngIf="order.notes && order.notes !== ''">
            <p class="fontsize ml-3">Notas</p>
            <p class="fontsize ml-3">{{order.notes}}</p>
          </div>
        </div>
        <hr class="my-0" />
        <div>
          <h1 class="fontstrong fontsize">TOTAL</h1>
          <table>
            <tr>
              <td class="fontsize">Subtotal:</td>
              <td class="fontsize">{{orderObj.orderPrice | number: '1.2-2'}}</td>
            </tr>
            <tr>
              <td class="fontsize">- Descuento:</td>
              <td class="fontsize">{{orderObj.orderDiscount | number: '1.2-2'}}</td>
            </tr>
            <tr>
              <td class="fontsize">- Descuento puntos de fidelidad:</td>
              <td class="fontsize">{{orderObj.fidelityDiscount | number: '1.2-2'}}</td>
            </tr>
            <tr *ngIf="!orderObj.table">
              <td class="fontsize">Precio Delivery:</td>
              <td class="fontsize">{{orderObj.deliveryPrice | number: '1.2-2'}}</td>
            </tr>
            <tr *ngIf="!orderObj.table">
              <td class="fontsize">- Descuento Delivery:</td>
              <td class="fontsize">{{orderObj.deliveryDiscount | number: '1.2-2'}}</td>
            </tr>
            <tr>
              <td class="fontsize">Precio Total:</td>
              <td class="fontsize">{{orderObj.totalPrice | number: '1.2-2'}}</td>
            </tr>
          </table>
          <br />
        </div>
      </div>
      <div *ngIf="isSecondPrint || isComanda">
        <h1 class="fontstrong center fontcomandatitle">COMANDA:</h1>
        <p class="fontsize">Nº Orden: {{orderObj.number ? orderObj.number : 0}}</p>
        <p class="fontsize">Fecha: {{orderObj.createdAt | date: 'short'}}</p>
        <p *ngIf="orderObj.client" class="fontsize">Cliente: {{orderObj.client.fullname}}</p>
        <div *ngIf="orderObj.table && orderObj.table.room">
          <p class="fontsize">Sala: {{orderObj.table.room.name}}</p>
          <p class="fontsize">Mesa: Nº{{orderObj.table.number}}</p>
        </div>
        <hr class="mb-0" />
        <div *ngFor="let pZones of preparationZones">
          <p class="fontsize mb-1">Zona de Preparación: {{pZones.name}}</p>
          <hr class="my-0" />
          <h1 class="fontstrong center fontsize mt-1">Productos:</h1>
          <div *ngFor="let order of pZones.items">
            <div class="mt-2">
              <p class="fontsize">
                - {{order.quantity}} {{order.product}} ({{order.productVariant}})
              </p>
              <div *ngIf="order.notes && order.notes !== ''" class="my-1">
                <p class="fontsize ml-3">Notas:</p>
                <p class="fontsize ml-3">({{order.notes}})</p>
              </div>
            </div>
            <div *ngIf="order.specifications && order.specifications.length > 0" class="my-2">
              <p class="fontsize  ml-3">Especificaciones:</p>
              <div *ngFor="let spec of order.specifications; let i = index">
                <p class="fontsize  ml-3">x {{spec.name ? spec.name : spec}}</p>
              </div>
            </div>
            <div *ngIf="order.additives && order.additives.length > 0" class="my-1">
              <div *ngFor="let addit of order.additives | groupBy: 'groupName' | pairs">
                <div *ngIf="addit[0] !== 'undefined'" class="my-1">
                  <p class="fontsize  ml-3">{{addit[0]}}:</p>
                </div>
                <div *ngIf="addit[0] === 'undefined'" class="my-1">
                  <p class="fontsize  ml-3">Acompañamientos:</p>
                </div>
                <div *ngFor="let g of addit[1]">
                    <p class="fontsize  ml-3">x {{g.product}}</p>
                </div>
              </div>
            </div>
            <div *ngIf="order.extras && order.extras.length > 0" class="my-1">
              <p class="fontsize ml-3">Extras:</p>
              <div *ngFor="let extra of order.extras">
                <p class="fontsize ml-3">x {{extra.quantity}} {{extra.product ? extra.product : extra.name}}</p>
              </div>
            </div>
            <hr class="my-0" />
          </div>
          <br />
        </div>
      </div>
      <div *ngIf="qrDomain !== null && !isComanda &&
          orderObj.deliveryMethod.value === 'delivery' &&
          (orderObj.currentStatus === 'completed' || orderObj.currentStatus === 'prepared')"
        class="d-flex">
        <qrcode [qrdata]="qrDomain+'driver/'+appId+'/'+orderObj.objectId" [width]="200" [errorCorrectionLevel]="'M'"
          [elementType]="'url'"></qrcode>
      </div>
      <div class="show-print">-</div>
    </div>
  </div>
  <mat-dialog-actions>
    <button mat-raised-button class="closeButton" ngxPrint (click)="print()">
      <mat-icon>print</mat-icon>
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
